import React, { Component } from 'react';
import './builderTypeTabs.css';
import { BUILDER_TYPES } from '../../config/constants';
import { connect } from 'react-redux';
import { setBuilderType } from '../../redux/actions/builderType';

class BuilderTypeTabs extends Component {

    setActiveBuilderType = (activeBuilder) => {
        this.props.setBuilderType(activeBuilder);
    };

    tabClassName = (type) => {
        return `tab ` + (this.props.activeBuilderType === type ? `active-tab` : '');
    };

    render() {
        return (
            <>
                <button
                    className={this.tabClassName(BUILDER_TYPES.FORM)}
                    onClick={() => this.setActiveBuilderType(BUILDER_TYPES.FORM)}
                >Form</button>
                <button
                    disabled={!('UPDATE_FORM_CONFIG' in window)}
                    className={this.tabClassName(BUILDER_TYPES.SUCCESS_PAGE)}
                    onClick={() => this.setActiveBuilderType(BUILDER_TYPES.SUCCESS_PAGE)}
                >Success</button>
            </>
        )
    }
}

export default connect(
    state => ({
        activeBuilderType: state.activeBuilderType,
    }),
    {
        setBuilderType,
    }
)(BuilderTypeTabs);